import { CloseIcon, CloseIconProps, IconButton } from 'opensolar-ui'
import { FC } from 'react'

interface DialogCloseButtonProps extends CloseIconProps {
  className?: string
  onClick: () => void
  disabled?: boolean
}

export const DialogCloseButton: FC<DialogCloseButtonProps> = ({ onClick, className, disabled, ...props }) => {
  return (
    <IconButton className={className} onClick={onClick} id="dialog-close-button" disabled={disabled}>
      <CloseIcon {...props} />
    </IconButton>
  )
}
